/**
 * Copyright (c) 2025 Kalpit Patel
 *
 * Sole Developer and Owner:
 * Kalpit Patel is the sole developer and creator of this entire application.
 * No other individual or entity has contributed to the development of this software.
 * All rights reserved.
 *
 * This file is part of AksharJobs application.
 */

import { createPortal } from 'react-dom';
import { useEffect } from 'react';
import Aurora from './Aurora';
import './AuthMobileAurora.css';

const AuthMobileAurora = () => {
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const syncBodyClass = () => {
      document.body.classList.toggle('auth-mobile-aurora-active', mediaQuery.matches);
    };

    syncBodyClass();
    mediaQuery.addEventListener('change', syncBodyClass);

    return () => {
      mediaQuery.removeEventListener('change', syncBodyClass);
      document.body.classList.remove('auth-mobile-aurora-active');
    };
  }, []);

  return createPortal(
    <div className="auth-mobile-aurora-bg" aria-hidden="true">
      <div className="auth-mobile-aurora-canvas">
        <Aurora
          colorStops={['#ff8c42', '#ffa726', '#14b8a6']}
          blend={0.55}
          amplitude={0.9}
          speed={0.4}
        />
      </div>
      <div className="auth-mobile-aurora-blur" />
      <div className="auth-mobile-aurora-veil" />
    </div>,
    document.body
  );
};

export default AuthMobileAurora;
